import { Icon, Tooltip } from '@genial/components';
import { Box } from 'native-base';
import React from 'react';

namespace InfoTooltipTypes {
  export interface Props {
    tooltipText: string;
  }
}

export const InfoTooltip: React.FC<InfoTooltipTypes.Props> = ({ tooltipText }) => (
  <Tooltip label={tooltipText} maxWidth="220px">
    <Box>
      <Icon name="Info" color="product.contacorrente" size="xxxs" testID="info-icon" />
    </Box>
  </Tooltip>
);
